import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetAuftraegeMutation } from '../../api/AgSachbearbeiterAPI';
import AuftragCustomerDetailComponent from '../../component/AuftragCustomerDetailComponent/AuftragCustomerDetailComponent';
import { IManagerProfileAuftragResponseDto } from '../../types/Types';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from "./agsachbearbeiter.module.scss";

/**
 * @author noone
 */
export default function AgSbAuftragsListe() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<IManagerProfileAuftragResponseDto[]>([]);
  const [uid, setUid] = useState<string>();

  const [getAuftraege] = useGetAuftraegeMutation();

  const init = () => {
    setLoaded(false);
    getAuftraege().unwrap()
      .then(data => setListe(data))
      .catch((e) => console.log(e))
      .finally(() => setLoaded(true));
  }

  const onSpeichern = () => {
    setUid(undefined);
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    init();
  }, [getAuftraege]);

  return (
    <>
      <LandingpageHeader />
      <div style={{ marginLeft: "3em", marginRight: "3em" }} >

        {!uid &&
          <>
            <div>

              <button
                onClick={() => {
                  navigate({
                    pathname: "/",
                    search: ""
                  });
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragMain.backButton')}
              </button>

            </div>

            <h3>{t('deTranslation.auftragMain.titel')}</h3>

            <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "2fr 2fr 2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
              <div>Auftragsnr.</div>
              <div>Bearbeiter</div>
              <div>Status</div>
              <div style={{ textAlign: "end" }}>
                Option
              </div>
            </div>
            {liste?.map((e, index) =>
              <div key={index}>
                <div key={index} style={{ display: "grid", gridTemplateColumns: "2fr 2fr 2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                  <div>{e.auftragsnr_ag}</div>
                  <div>{e.bearbeiterName}</div>
                  <div>{e.status}</div>
                  <div style={{ textAlign: "end" }}>
                    <button onClick={() => setUid(e.uid)} className={styles.wga} ><i className="bi bi-pencil"></i></button>
                  </div>
                </div>
              </div>)
            }

          </>
        }

        {uid &&
          <>
            <div>

              <button
                onClick={() => setUid(undefined)}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
              </button>

            </div>

            <h3>{t('deTranslation.auftragDetails.titel')}</h3>
            <AuftragCustomerDetailComponent uid={uid} onSpeichern={onSpeichern} />
          </>
        }

        <Footer />
      </div >
    </>
  );

}


